import {
  fetchTattvaNode,
  fetchTattvaRelated,
  fetchTattvaDebug,
  libraryGraphKey,
} from "./tattva-api";

/**
 * Browser console helper: window.testTattva("deity:shiva")
 */
export async function testTattva(idOrType, libraryId) {
  const anchorId =
    libraryId != null && typeof idOrType === "string"
      ? libraryGraphKey(idOrType, libraryId)
      : idOrType;

  if (!anchorId) {
    console.warn("[testTattva] Provide id e.g. deity:shiva or testTattva('deity','shiva')");
    return null;
  }

  console.group(`[testTattva] ${anchorId}`);

  try {
    const { node, draft, source } = await fetchTattvaNode(anchorId);
    console.log("node (%s):", source, node);
    if (draft) console.log("draft:", draft);
    console.log("edges:", node?.edges ?? []);
  } catch (e) {
    console.error("node fetch failed:", e?.response?.data || e.message);
  }

  try {
    const related = await fetchTattvaRelated(anchorId);
    console.log("related nodes:", related.nodes);
    console.log("related edges:", related.edges);
    console.log("by_relation:", related.by_relation);
    console.log("by_type:", related.by_type);
  } catch (e) {
    console.error("related fetch failed:", e?.response?.data || e.message);
  }

  try {
    const debug = await fetchTattvaDebug();
    console.log("graph debug stats:", debug.stats);
    console.log("orphans:", debug.orphan_nodes?.map((n) => n.id));
    console.log("invalid_edges:", debug.invalid_edges);
  } catch (e) {
    console.warn("debug (admin only):", e?.response?.data?.detail || e.message);
  }

  console.groupEnd();
  return { anchorId };
}

export function installTattvaTestConsole() {
  if (typeof window !== "undefined") {
    window.testTattva = testTattva;
  }
}
